import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import CanonicalTag from '@/components/CanonicalTag';
import aduEmptyLotImage from '@/assets/adu-empty-lot.jpg';

const CanYouBuildADUEmptyLotCalifornia = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/build-adu-empty-lot-california" />
      
      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh]">
            <button 
              onClick={closeCalendlyModal} 
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              ✕
            </button>
            <iframe 
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-4 py-8">
          {/* Hero Section */}
          <div className="mb-12">
            <img 
              src={aduEmptyLotImage} 
              alt="ADU construction on empty lot" 
              className="w-full h-64 md:h-96 object-cover rounded-lg mb-8"
            />
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
              Can You Build an ADU on an Empty Lot in California?
            </h1>
            
            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              Understand the legal possibilities and zoning rules for building an ADU on an empty lot in California. Know city-specific guidelines clearly.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                California State Regulations for Empty Lot ADUs
              </h2>
              <p className="text-white leading-relaxed mb-6">
                California state law generally requires a primary dwelling unit before allowing ADU construction. Most jurisdictions mandate that a main house must exist on the property before an ADU can be built, as ADUs are defined as "accessory" to a primary structure.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                City-Specific Guidelines (Los Angeles, San Diego, San Jose)
              </h2>
              <p className="text-white leading-relaxed mb-6">
                While state law is restrictive, some cities have unique provisions. Los Angeles, San Diego, and San Jose each have specific zoning exceptions that may allow ADU-first construction under special circumstances, typically requiring conditional use permits and meeting strict criteria for density and infrastructure.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Alternatives if ADUs are Not Allowed on Vacant Lots
              </h2>
              <p className="text-white leading-relaxed mb-6">
                When ADU construction isn't permitted on empty lots, consider building a small primary residence first, then adding an ADU later. Alternatively, explore tiny home communities, manufactured homes, or other housing types that may be permitted on vacant lots in your specific zoning area.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Frequently Asked Questions
              </h2>
              <div className="text-white leading-relaxed space-y-6">
                <div>
                  <p className="font-semibold mb-2">Q: Can I legally build an ADU first on a vacant lot?</p>
                  <p>A: Typically, a primary home must be present; exceptions depend on local zoning.</p>
                </div>
                
                <div>
                  <p className="font-semibold mb-2">Q: Which cities allow ADUs on vacant lots in California?</p>
                  <p>A: Few cities permit this without primary structures, often requiring conditional use permits.</p>
                </div>
              </div>
            </section>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button 
              onClick={openCalendlyModal}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-3 text-lg"
            >
              Book & Schedule
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-3 text-lg"
            >
              <Link to="/landing">Learn More</Link>
            </Button>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default CanYouBuildADUEmptyLotCalifornia;